import type { DemandStatus, PaymentMode } from "@/services/types";

export const PAYMENT_MODES: { value: PaymentMode; label: string; icon: string }[] = [
  { value: "cash", label: "Cash", icon: "ri-bank-card-line" },
  { value: "upi", label: "UPI", icon: "ri-smartphone-line" },
  { value: "bank_transfer", label: "Bank transfer", icon: "ri-bank-line" },
  { value: "cheque", label: "Cheque", icon: "ri-file-list-3-line" },
  { value: "member_account", label: "Member Account", icon: "ri-wallet-3-line" },
];

export function paymentModeLabel(mode: PaymentMode): string {
  return PAYMENT_MODES.find((m) => m.value === mode)?.label ?? mode;
}

export function paymentModeIcon(mode: PaymentMode): string {
  return PAYMENT_MODES.find((m) => m.value === mode)?.icon ?? "ri-bank-card-line";
}

export function referenceRequired(mode: PaymentMode): boolean {
  return mode !== "cash" && mode !== "member_account";
}

export interface DemandStatusMeta {
  label: string;
  badge: "pending" | "partial" | "paid" | "overdue";
  tone: "default" | "success" | "warning" | "danger";
}

export function demandStatusMeta(status: DemandStatus, overdue: boolean): DemandStatusMeta {
  if (status === "paid") return { label: "Paid", badge: "paid", tone: "success" };
  if (status === "partial") return { label: "Partial", badge: "partial", tone: "warning" };
  if (overdue) return { label: "Overdue", badge: "overdue", tone: "danger" };
  return { label: "Pending", badge: "pending", tone: "default" };
}